import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { LoaderService } from '../../shared/services/loader.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
  @Input() mainMessage: string = 'COMMON.LOADING';
  @Input() subMessage: string = 'COMMON.PLEASE_WAIT';
  @Input() show: boolean = false;

  constructor(public loader: LoaderService) {}
}
